var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgUnitinline = function SvgUnitinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1C72E7",
    d: "M4.587.922a.837.837 0 0 0-.388.101L.507 2.87a.917.917 0 0 0-.408 1.237.917.917 0 0 0 1.237.407L4.143 3.11l5.548 13.183c.212.489.498.923.84 1.301a2.788 2.788 0 0 0-2.225 2.714 2.777 2.777 0 0 0 2.77 2.769 2.777 2.777 0 0 0 2.768-2.77c0-.442-.12-.858-.304-1.236a4.498 4.498 0 0 0 2.26-.343l6.722-2.944a.92.92 0 0 0 .506-1.199.929.929 0 0 0-1.198-.517c-.019.01-.029.018-.047.027l-6.72 2.946a2.758 2.758 0 0 1-3.665-1.47L5.463 1.486a.925.925 0 0 0-.876-.563ZM17.869 4.67a.997.997 0 0 0-.36.074l-6.794 2.888a.915.915 0 0 0-.489 1.21l2.722 6.092a.92.92 0 0 0 1.21.49l6.804-2.88a.934.934 0 0 0 .489-1.21l-2.733-6.101a.92.92 0 0 0-.85-.563Zm-6.794 14.714c.517 0 .923.406.923.923a.914.914 0 0 1-.923.923.914.914 0 0 1-.923-.923c0-.517.406-.923.923-.923Z"
  })));
};

export default SvgUnitinline;